// @ts-strict
import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '../services/utils/index';

@Pipe({
  name: 'asOfDate'
})
export class LMAsOfDate implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) { }

  transform(title: string, userFolderAsOfDate: number): string {
    if (!userFolderAsOfDate) {
      return title;
    }

    const formattedDate = this.lmFormatUtilService.yyyymmddToDisplay(userFolderAsOfDate, { forceToPattern: Soho.Locale.calendar().dateFormat.long });

    if (!formattedDate) {
      return title;
    }

    return [
      Soho.Locale.translate('CreateReportAsOfDateLabel'),
      ' ',
      formattedDate
    ].join(' ');
  }
}
